/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archive_ListingInputs */

const en_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive Listing`)
};

const es_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivar anuncio`)
};

const fr_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiver l'annonce`)
};

const de_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat archivieren`)
};

const ja_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品をアーカイブ`)
};

const zh_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`归档商品`)
};

const ar_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أرشفة الإعلان`)
};

const id_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arsipkan Listing`)
};

const it_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivia Annuncio`)
};

const ru_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В архив`)
};

const pt_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivar Anúncio`)
};

const ko_archive_listing = /** @type {(inputs: Archive_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 보관`)
};

/**
* | output |
* | --- |
* | "Archive Listing" |
*
* @param {Archive_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const archive_listing = /** @type {((inputs?: Archive_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archive_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_archive_listing(inputs)
	if (locale === "es") return es_archive_listing(inputs)
	if (locale === "fr") return fr_archive_listing(inputs)
	if (locale === "de") return de_archive_listing(inputs)
	if (locale === "ja") return ja_archive_listing(inputs)
	if (locale === "zh") return zh_archive_listing(inputs)
	if (locale === "ar") return ar_archive_listing(inputs)
	if (locale === "id") return id_archive_listing(inputs)
	if (locale === "it") return it_archive_listing(inputs)
	if (locale === "ru") return ru_archive_listing(inputs)
	if (locale === "pt") return pt_archive_listing(inputs)
	return ko_archive_listing(inputs)
});